/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Olive_Coral_Pike_MendInputs */

const en_olive_coral_pike_mend = /** @type {(inputs: Olive_Coral_Pike_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managers`)
};

const de_olive_coral_pike_mend = /** @type {(inputs: Olive_Coral_Pike_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managers`)
};

/**
* | output |
* | --- |
* | "Managers" |
*
* @param {Olive_Coral_Pike_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_coral_pike_mend = /** @type {((inputs?: Olive_Coral_Pike_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Coral_Pike_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_coral_pike_mend(inputs)
	return de_olive_coral_pike_mend(inputs)
});